<template>
	<div :class='$vuetify.breakpoint.mdAndDown ? "pa-2" : "px-16"'>
		<v-row dense>
			<v-col class='font-weight-bold' cols='12'>
				Ort oder Postleitzahl:
			</v-col>

			<v-col cols='12'>
				<v-row align-content='center' dense justify='center'>
					<VuetifyGooglePlaces
						:api-key='apiKey'
						types='address'
						country='de'
						placeholder='Input your place'
						version='weekly'
					/>

					<v-tooltip
						class='primary'
						color='primary'
						open-delay='80'
						top
					>
						<template v-slot:activator='{ on }'>
							<v-btn
								class='primary-light-text location-btn'
								dense
								outlined
								solo
								@click='getLocationFromBrowser'
								v-on='on'
							>
								<v-icon size='18'>
									far fa-location
								</v-icon>
							</v-btn>
						</template>

						<span>Aktuellen Standort verwenden</span>
					</v-tooltip>

				</v-row>
			</v-col>

			<v-col
				v-if='errorMessage'
				class='red--text font-weight-bold'
				cols='12'
				style='font-size: 15px'
			>
				{{ errorMessage }}
			</v-col>

			<v-col cols='12'>
				<v-icon class='mr-1' size='15' style='margin-bottom: 2px'>
					far fa-info-circle
				</v-icon>
				Wir zeigen dir alle verfügbaren Fahrzeuge an, sortiert nach der nähe zu Deinem Ort.
			</v-col>

			<v-col cols='12' class='mt-2 font-weight-bold'>
				Aktueller Standort: <span v-if='location.formatted_address' class='green--text'>{{ location.formatted_address }}</span><span
					v-else
				>Keine auswahl</span>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import BaseFilterMixin from './BaseFilterMixin'
  import VuetifyGooglePlaces from 'vue-google-places'

	const throttle = require('lodash.throttle')

	export default {
		name: 'LocationFilter',
    components: {VuetifyGooglePlaces},
		mixins: [BaseFilterMixin],
		data: () => {
			return {
			  apiKey: 'AIzaSyCZrfmdDTC_pMC6BD9IHLk6d7Np1OofmLI',
				location: {
					lat: undefined,
					lng: undefined,
					formatted_address: ''
				},
				search: '',
				predictions: [],
				placeholder: 'z.B. 97070, Würzburg',
				loading: false,
				errorMessage: ''
			}
		},

		computed: {
			infoText() {
				let text = ''

				if (this.loading) text = 'Vorschläge werden geladen...'
				else if (this.predictions.length) text = ''
				else text = 'Keine passenden Orte gefunden'

				return text
			}
		},

		watch: {
			search(newValue, oldValue) {
				if (newValue === oldValue) return

				// prevent retrigger if user selects a prediction
				const predictionSelected = this.predictions.find(p => p.formatted_address === newValue)

				this.predictions = []

				if (predictionSelected || !newValue || newValue.length < 2) this.loading = false
				else {
					this.loading = true
					this.getPredictions(newValue)
				}
			},

			location(val) {
        if (!val) {
          this.location = {
            lat: undefined,
            lng: undefined,
            formatted_address: ''
          }
          this.predictions = []
        } else {
          if (!this.location.lat || !this.location.lat) this.updateFilter({})
          else this.updateFilter({
            value: {latitude: this.location.lat, longitude: this.location.lng},
            label: this.location.formatted_address
          })
        }
      }
		},

		mounted() {
			if (this.filter.selectedValues && this.filter.selectedValues[0]) {
				const loc = this.filter.selectedValues[0]

				const locObj = {
					lat: loc.lat,
					lng: loc.lng,
					formatted_address: loc.label
				}

				this.location = locObj
				this.predictions = [locObj]
				this.search = loc.label
				this.placeholder = loc.label
			}
		},

		methods: {
			getPredictions: throttle(function (query) {
				this.$http.get('services/maps/autocomplete' + '?query=' + encodeURI(query))
				.then(response => {
					this.predictions = response
          this.errorMessage = ''
					this.loading = false
				}).catch(err => {
          this.errorMessage = 'Bei der Abfrage des Ortes ist ein Fehler aufgetreten'
          console.error('locationError:', err)
          this.loading = false
        })
			}, 600),


			getLocationFromBrowser() {
				if (navigator.geolocation) {
					this.loading = true
					navigator.geolocation.getCurrentPosition(
						this.setLocationFromBrowser,
						(err) => {
							this.errorMessage = 'Geolocation wird nicht unterstützt'

							if (err.code === 1) this.errorMessage = 'Bitte erlauben Sie, dass diese Seite Ihren Standort verwenden darf'

							this.loading = false
							console.error('locationError:', err)
						})
				} else {
					this.errorMessage = 'Geolocation wird nicht unterstützt'
				}
			},

			setLocationFromBrowser(position) {
				const self = this

				this.$http.get('services/maps/getAddressFromGeolocation', {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				}).then(res => {
						const locObj = {
							formatted_address: res,
							lng: position.coords.longitude,
							lat: position.coords.latitude
						}

						self.location = locObj
						self.predictions = [locObj]
						self.search = res
						self.placeholder = res

            self.errorMessage = ''
						self.loading = false
					}
				).catch(err => {
					this.errorMessage = 'Geolocation wird nicht unterstützt'
					console.error('locationError:', err)
					this.loading = false
				})
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.location-input {
		border-right: 1px solid !important;
		border-top-right-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
	}

	.location-btn {
		height: 40px !important;
		border-left: 1px solid !important;
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
	}
</style>